// extracted by mini-css-extract-plugin
module.exports = {"tickerContainer":"_a0e444e","ticker":"_14bb7f4","revealContainer":"_3f68a00","revealText":"_5b920da"};